import { render, staticRenderFns } from "./DisclaimerFooterLink.vue?vue&type=template&id=1c2e53b9&scoped=true&"
import script from "./DisclaimerFooterLink.vue?vue&type=script&lang=js&"
export * from "./DisclaimerFooterLink.vue?vue&type=script&lang=js&"
import style0 from "./DisclaimerFooterLink.vue?vue&type=style&index=0&id=1c2e53b9&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c2e53b9",
  null
  
)

export default component.exports